import React from 'react'
import cx from 'classnames'

import PageLink from '@/link.js'
import Image from '@/image.js'

class HomeHero extends React.Component {
  constructor () {
    super()
    this.state = {
      visible: false
    }
  }
  componentDidMount () {
    setTimeout(() => {
      this.setState({
        visible: true
      })
    }, 1000)

  }

  render () {
    const {
      data
    } =  this.props
    return (
      <div>
        <div className={cx('hero__home rel container--xl ma', {
          'is-animated': this.state.visible
        })}>
          <div className='hero__home-images f jcb aic'>
            {data.imageGrid.map(image => (
              <Image className='hero__home-image shadow animate a-o a-t' key={image._key} imageId={image.imageId} alt='restore' />
            ))}
          </div>
          <div className='p15 hero__home-text container--e'>
            <h1 className='h1-display mb0 pb0  animate a-o a-t'>{data.title}</h1>
            <p className='s28 mb0 pb1  animate a-o a-t' dangerouslySetInnerHTML={{ __html: data.subTitle.replace(/[\r\n]+/g, '<br />') }} />
            <PageLink to='/about' className='button button__peach  animate a-o a-t block button__outline'>
              <span>Learn More</span>
            </PageLink>
          </div>
        </div>
      </div>
    )
  }
}

export default HomeHero